import React, { Component } from "react";
import InputText from "../../../../../common/components/input-text/input-text";
import Button from "../../../../../home/button-classic/button-classic";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { connect } from "react-redux";
import ACTION from "../../../../../common/action_constant";
import { getCookie } from "../../../../../utils/cookies.js";
import Switch from "react-switch";
import { getUserCompanyId, AWL_COMPANY_IDS } from "../../../../../utils/common";
import { validationCheck } from "../../../../../utils/validate";
import { setItemToSessionStorage } from "../../../../../utils/sessionStorage.js";
import { GoVerified } from "react-icons/go";
import { IoIosWarning } from "react-icons/io";
import actions from "../../../../../common/action_constant";

class AddItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        company_id: JSON.parse(getCookie("user")).company_id,
        user_id: this.props.data.user_id,
        driver_id: this.props.data.driver_id,
        user_name:this.props.data.user_name,
        driver_name: this.props.data.driver_name,
        cell_no: this.props.data.cell_no,
        dl_no: this.props.data.dl_no,
        dob: this.props.data.dob,
        driver_acc_no: this.props.data.driver_acc_no,
        driver_ifsc_code: this.props.data.driver_ifsc_code,
        driver_alternative_location_id: this.props.data.driver_alternative_location_id,
        preferredroute: this.props.data.preferredroute || [],
        // user_name: this.props.data.user_name,
        driver_detail_validity_date: this.props.data.driver_detail_validity_date,
        block_data:this.props.data.block_data || [],
        dlName:this.props.data.dlName,
        is_blocked: this.props.data.is_blocked || false,
        block_remarks: this.props.data.block_remarks || '',
        blocked_by: this.props.data.blocked_by || '' ,
        unblock_remarks: this.props.data.unblock_remarks || '',  
        unblocked_by: this.props.data.unblocked_by || '',
        unblocked_user_id: this.props.data.unblocked_user_id || '',
        unblock_data:this.props.data.unblock_data || []
      },
      fetchbuttonclicked: false,
      blockedUser: false,
      dlValidationStatus: {
        isValid: "",
        validationMessage: "",
      },
      fetchMessage: "",
      fetchStatus: "",
      errorMsg: ""
    };
  }

  componentDidMount() {
    // this.props.getCompanyTransporters();
    setItemToSessionStorage('driverIn', this.props.data);
  }

  handleChange = (id, selectedOption) => {
    let { data } = this.state;
    data[id] = selectedOption.label;
    this.setState({ data });
  };

  onChangeHandler = (value, id, isType) => {
    let { data } = this.state;
    if (id === 'driver_ifsc_code' || id === 'dl_no'){
      value = value.replace(/[^A-Za-z0-9]/g, '');
      value = value.slice(0, 16);
    }
    const result = validationCheck(value, this.state.data[id], isType);
    data[id] = result;
    this.setState({ data });
  };

  SelectDate = (id, selectedOption) => {
    let { data } = this.state;
    data[id] =  selectedOption.valueOf();
    this.setState({ data });
  };
  onSave = () => {
    const { data } = this.state;
    const {driver_detail_validity_date, dob } = this.state.data;
    if(!!data.is_blocked){
      data.blocked_by = JSON.parse(getCookie("user")).admin_name 
            || JSON.parse(getCookie("user")).user_name 
            || '';
    }
    if(!data.is_blocked){
       data.is_blocked = data.is_blocked; 
       data.unblocked_by = JSON.parse(getCookie("user")).admin_name 
             || JSON.parse(getCookie("user")).user_name 
             || '';
       data.unblocked_user_id = JSON.parse(getCookie("user")).user_id;
    }
    // Basic field validation
    if (!this.validateCheck()) {
      this.setState({
        errorMsg: "Please add all mandatory fields",
      });
      return;
    }
    const hasMaskedData = [
      data.driver_name,
      data.cell_no,
      data.driver_alternative_location_id,
    ]
      .filter(Boolean)
      .some((field) => field.includes("*"));

    if (hasMaskedData) {
      this.setState({
        errorMsg:
          "Some fields contain masked (*) data. Please enter complete driver details before saving.",
      });
      return;
    }
    if (!this.validateCheck()) {
    this.setState({ errorMsg: "Please add all mandatory fields" });
    return;
  }
      const today = moment().startOf("day");
  if (
    !driver_detail_validity_date ||
    moment(driver_detail_validity_date).isBefore(today)
  ) {
    this.setState({
      errorMsg: "Please select a valid Driving Licence Validity Date.",
    });
    return;
  }

  if (dob && moment().diff(moment(dob), "years") < 18) {
    this.setState({ errorMsg: "Driver must be at least 18 years old." });
    return;
  }
    data.driver_detail_validity_date = driver_detail_validity_date
    ? driver_detail_validity_date.valueOf()
    : undefined;

  this.setState({ errorMsg: "" });
  this.props.toggleAdd("Edit");
  this.props.updateDriverInfo(data);
};
  validateCheck = () => {
    const { data } = this.state;
    if (data.driver_name && data.cell_no && data.dl_no && data.driver_detail_validity_date && data.dlName) {
      return true;
    } else return false;
  };
  addLocation = () => {
    let { data } = this.state;
    data.preferredroute.push({ source: "", destination: "" });
    this.setState({ data });
  };
  deleteLocation = (index) => {
    const { data } = this.state;
    data.preferredroute.splice(index, 1);
    this.setState({ data });
  };

  uploadfiles = (e, name) => {
    const { dispatch } = this.props;
    const { driverinfo } = this.state.data;
    console.log("edit data",driverinfo)
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch({
      type: ACTION.DATA_GOVERNANCE.UPLOAD_VEHICLE_FIELS,
      formData,
      onSuccess: (details) => {
        const { data } = this.state;
        data[name] = details;
        this.setState({ data });
      },
    });
  };
  onUpload = () => {
    this.uploadUrl.click();
  };
     handleFileClickWithpresignedUrl = (name = "") => {

    const { dispatch } = this.props;

    dispatch({

      type: actions.HOME.GET_PRESIGNED_DOWNLOAD_URL,

      fileName: name,
      trip_id: "",
      method_name: "",

      onSuccess: ((link) => {

        console.log("link", link);

        window.open(link, '_blank');

      })

    })

  }

handleSwitch = (checked) => {
  let { data } = this.state;
  data.is_blocked = checked;
  data.blocked_by =
    JSON.parse(getCookie("user")).admin_name ||
    JSON.parse(getCookie("user")).user_name ||
    '';
  
  if (checked) {
    data.block_remarks = '';
  } else {
    data.unblock_remarks = '';
  }

  this.setState({ data, blockedUser: true });
};

FetchDriverDetails = () => {
    const { dispatch } = this.props;
    const { data } = this.state;
    const { dl_no, dob } = data;
    console.log("Dob:",dob)
    const dateObj = new Date(dob);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    const formattedDob = `${year}-${month}-${day}`;

    const params = { dlnumber: dl_no, dob: formattedDob };

    dispatch({
      type: ACTION.MASTER.VEHICLE_PLANNING.DRIVER_DETAILS_FROM_ULIP,
      queryParams: params,
      onSuccess: (response) => {
        let validationStatus = {
          isValid: "",
          validationMessage: "",
        };

        const dlData = response?.data?.response?.dldetobj?.[0] || null;

        if (dlData && (dlData.dlobj?.dlLicno || dlData.bioObj?.bioDlno)) {
          validationStatus.isValid = "success";
          validationStatus.validationMessage = "DL number is valid";

          const driverName =
            dlData.bioObj?.bioFullName || dlData.dlobj?.bioFirstName || "";
          const driverContact = dlData.bioObj?.bioMobileNo || "";
          const driverLocation =
            dlData.bioObj?.bioPermAdd1 +
            dlData.bioObj?.bioPermAdd2 +
            dlData.bioObj?.bioPermAdd3 ||
            dlData.bioObj?.bioTempAdd1 +
            dlData.bioObj?.bioTempAdd2 +
            dlData.bioObj?.bioTempAdd3 ||
            "";

          const driverDLValidityDate = dlData.dlobj?.dlNtValdtoDt
            ? moment(dlData.dlobj.dlNtValdtoDt, "YYYY-MM-DD").valueOf()
            : "";


          // ✅ Autofill
          this.setState({
            dlValidationStatus: validationStatus,
            data: {
              ...data,
              driver_name: driverName,
              cell_no: driverContact,
              driver_alternative_location_id: driverLocation,
              driver_detail_validity_date: driverDLValidityDate
            },
          });
        } else {
          validationStatus.isValid = "error";
          validationStatus.validationMessage = "DL number does not exist";
          this.setState({ dlValidationStatus: validationStatus });
        }
      },
    });
  };
    convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  onChange = (e) => {
    const file = e.target.files[0];
    this.uploadfiles(e, "dlName");   // existing logic
    if (file) {
      this.FeatchOcrDetails(file);   // send file to API
    }
  };


  handleOcrUpload = async (file) => {
    const base64String = await this.convertToBase64(file);

    // Now send base64 string to API
    this.FeatchOcrDetails(base64String);
  };

  handleOcrSuccess = (resp) => {
    const ocr = resp?.data || {};

    this.setState((prev) => ({
      data: {
        ...prev.data,
        driver_name: ocr.name || "",
        dl_no: ocr.dl_number || "",
        driver_detail_validity_date: ocr.validity_tr
          ? moment(ocr.validity_tr, "DD/MM/YYYY").valueOf()
          : "",
        driver_alternative_location_id: ocr.address || "",
      }
    }));

    console.log("OCR Auto filled data", ocr);
  };


  FeatchOcrDetails = (file) => {
    const { dispatch } = this.props;

    const formData = new FormData();
    formData.append("file", file);

    dispatch({
      type: ACTION.MASTER.VEHICLE_PLANNING.DRIVER_DETAILS_OCR,
      payload: formData,
      onSuccess: this.handleOcrSuccess
    });
  };
  render() {
    let block=this.state.data.is_blocked;
    let { data, blockedUser } = this.state;
    console.log('data:', data)
    let {block_data,unblock_data}=this.state.data;
let {details}=this.state.data
console.log(data.driver_license_image)
    let isBlocked = block_data.filter(block => block.company_id === getUserCompanyId() && block.is_blocked === true)
    let isUnBlocked = unblock_data.filter(block => block.company_id === getUserCompanyId() && block.is_blocked === false)

  if (!blockedUser) {
  if (isBlocked && isBlocked.length > 0) {
    data.is_blocked = isBlocked[0].is_blocked;
    data.block_remarks = isBlocked[0].block_remarks || '';
  } else if (isUnBlocked && isUnBlocked.length > 0) {
    data.is_blocked = isUnBlocked[0].is_blocked;
    data.unblock_remarks = isUnBlocked[0].unblock_remarks || '';
  } else {
    // Default case
    data.is_blocked = false;
  }
}

    
    return (
      <div className="add-user-wrap">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup">
          <div className="pop-heading">Edit Driver Info</div>
          <div className="content add-item-details">
            <div style={{ display: "flex" }}>
              <div className="select-wrap">
                <InputText
                  label="DL No"
                  placeholder="DL No"
                  id="dl_no"
                  value={data.dl_no}
                  changeHandler={this.onChangeHandler}
                  length={"16"}
                  required
                />
              </div>

              <div className="select-wrap">
                <div className="data-picker" style={{ marginTop: "10px" }}>
                  <div className="label">Driver's date of birth{" "}
                    <span className="error-color">*</span>
                  </div>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    value={data.dob ? moment(data.dob).format('DD/MM/yyyy') : null}
                  
                    onChange={this.SelectDate.bind(
                      this,
                      "dob"
                    )}
                    placeholderText={"DD/MM/YYYY"}
                    maxDate={new Date()}
                    required
                  />
                  <button style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    padding: "8px 16px",
                    marginLeft: "4px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    height: "38px",
                    border: "none"
                  }}
                    onClick={() => this.FetchDriverDetails()}

                  >
                    Fetch
                  </button>
                </div>
              </div>
            </div>
            <div>
              {this.state.dlValidationStatus.validationMessage && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "8px",
                    padding: "8px 10px",
                    borderRadius: "6px",
                    backgroundColor:
                      this.state.dlValidationStatus.isValid === "success"
                        ? "rgba(0, 200, 83, 0.1)"
                        : "rgba(244, 67, 54, 0.1)",
                    border: `1px solid ${this.state.dlValidationStatus.isValid === "success"
                      ? "#4CAF50"
                      : "#F44336"
                      }`,
                    color:
                      this.state.dlValidationStatus.isValid === "success"
                        ? "#2E7D32"
                        : "#C62828",
                    fontSize: "14px",
                    fontWeight: 500,
                    maxWidth: "fit-content",
                  }}
                >
                  {this.state.dlValidationStatus.isValid === "success" ? (
                    <GoVerified style={{ fontSize: "18px", color: "#2E7D32" }} />
                  ) : (
                    <IoIosWarning style={{ fontSize: "18px", color: "#C62828" }} />
                  )}
                  <span>{this.state.dlValidationStatus.validationMessage}</span>
                </div>
              )}

            </div>
            <div className="select-wrap">
              <InputText
                label="driver_name"
                id="driver_name"
                value={data.driver_name.toUpperCase()}
                placeholder="Driver Name"
                changeHandler={this.onChangeHandler}
                length={"45"}
                required
              />
            </div>

            <div className="select-wrap">
              <InputText
                label="Driver Contact"
                id="cell_no"
                value={data.cell_no}
                placeholder="Driver Contact"
                changeHandler={this.onChangeHandler}
                length={"10"}
                isValidate={"numeric"}
                required
              />
            </div>
            <div className="select-wrap">
              <InputText
                label="Driver Location"
                id="driver_alternative_location_id"
                value={data.driver_alternative_location_id}
                placeholder="Driver Location"
                changeHandler={this.onChangeHandler}
                length={"45"}
              />
            </div>
            <div className="select-wrap">
              <InputText
                label="Driver A/C No"
                id="driver_acc_no"
                value={data.driver_acc_no}
                placeholder="Driver A/C No"
                changeHandler={this.onChangeHandler}
                length={"17"}
              />
            </div>

            <div className="select-wrap">
              <InputText
                label="IFSC"
                id="driver_ifsc_code"
                value={data.driver_ifsc_code}
                placeholder="IFSC"
                changeHandler={this.onChangeHandler}
                length={"11"}
              />
            </div>

            <div style={{ display: "flex" }}>
              <div className="select-wrap">
                <div className="data-picker">
                  <div className="label">Driver Dl Validity Date{" "}
                    <span className="error-color">*</span>
                  </div>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    // value={data.driver_detail_validity_date}
                    value={data.driver_detail_validity_date ? moment(data.driver_detail_validity_date).format('DD/MM/yyyy') : null}
                    onChange={this.SelectDate.bind(
                      this,
                      "driver_detail_validity_date"
                    )}
                    placeholderText={"DD/MM/YYYY"}
                    // minDate={new Date()}
                    required
                  />
                </div>
              </div>
              <div className="select-wrap" style={{ marginTop: "25px" }}>
                <span
                  style={{
                    fontSize: "13px",
                    color: "#868e96",
                    marginBottom: "10px",
                    marginRight: "5%",
                  }}
                >
                  DL Image
                  <span className="error-color">*</span>
                </span>
                <Button value={"Upload DL"} click={this.onUpload} />
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={(e) => {
                    this.uploadUrl = e;
                  }}
                  accept={'.jpeg, .jpg, .png'}
                  onChange={this.onChange}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
                <div>
                  {data.dlName && data.dlName.name ? (
                    // <a
                    //   href={data.dlName.url}
                    //   download
                    //   className={"theme-color fs-12 mt-5"}
                    // >
                    //   {data.dlName.name}
                    // </a>
                        <div
                        className="fs-12 mt-5 curP"
                        onClick={() =>
                          this.handleFileClickWithpresignedUrl(data.dlName.name)
                        }
                      >
                        {data.dlName.name}
                      </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div
              className="fBold fs-16 mt-10 mb-10 header-medium-color col-2 flex-1 "
            style={{  color: "#868e96" }}
            >
           {AWL_COMPANY_IDS.includes(data.company_id) ? <span> Driver Block</span>:
            block ? "Black listed" : "White listed" }
              <div className="mt-10">
                <Switch
                  onChange={this.handleSwitch}
                  onColor="#528aea"
                  checked={data.is_blocked}
                />
            </div>
           </div>
           
          {data.is_blocked ? (
              <div className="flex col-1">
                   <InputText
                      placeholder={
                       AWL_COMPANY_IDS.includes(data.company_id)
                       ? "Block remark"
                       : "Black listed remark"
                      }
                      label={
                       AWL_COMPANY_IDS.includes(data.company_id)
                       ? "Block remark"
                       : "Black listed remark"
                      }
                      id="block_remarks"
                      value={data.block_remarks}
                      changeHandler={(value) => {
                      let { data } = this.state;
                      data.block_remarks = value;
                      this.setState({ data });
                      }}
                    />
                   </div>
                  ) : (
  
                    <div className="flex col-1" style={{ marginLeft: "5px" }}>
                        <InputText
                            placeholder="White listed remark"
                            label="White listed remark"
                            id="unblock_remarks"
                            value={data.unblock_remarks}
                            changeHandler={(value) => {
                            let { data } = this.state;
                            data.unblock_remarks = value;
                            this.setState({ data });
                             }}
                           />
                      </div>
                    )}
                    
            <div
              className="label"
              style={{ fontSize: "20px", display: "inline-block" }}
            >
              Add Location
            </div>
            {
              <div className="button-add" onClick={this.addLocation}>
                ADD
              </div>
            }
            {data.preferredroute.map((value, index) => {
              return (
                <div className="details flex space-between" key={index}>
                  <div className="fiscal-section" style={{ width: "24%" }}>
                    <InputText
                      placeholder="Source"
                      id={"source"}
                      label="Source"
                      value={value.source}
                      changeHandler={(value) => {
                        let { preferredroute } = this.state.data;
                        preferredroute[index].source = value;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>
                  <div className="fiscal-section" style={{ width: "24%" }}>
                    <InputText
                      placeholder="Destinations"
                      id={"destination"}
                      label="Destination"
                      value={value.destination}
                      changeHandler={(value) => {
                        let { preferredroute } = this.state.data;
                        preferredroute[index].destination = value;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>

                  <div
                    className="button-add"
                    style={{ marginTop: "30px" }}
                    onClick={() => this.deleteLocation(index)}
                  >
                    X
                  </div>
                </div>
              );
            })}
          </div>
           <div className="submit-button">
            {this.state.errorMsg && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "8px",
                        padding: "8px 10px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                        border: "#F44336",
                        color: "#C62828",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >{this.state.errorMsg}</div>
                  )}
            <div className="button-section">
              <Button value="Save" click={this.onSave} />
            </div>
            <div className="button-section">
              <Button
                value="Cancel"
                click={() => this.props.toggleAdd("Edit")}
              />
            </div>
            </div>
          </div>
        </div>
    );
  }
}

export default connect()(AddItem);
